export default __webpack_public_path__ + "static/media/effect-128.1d2d1bef.mp3";